// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\StripeTransactionResponse

import { StripeTransactionStatus, StripeTransactionType } from './enums.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type StripeTransactionApiResponse = {
	id: string;
	amount: number;
	fee: number;
	net: number;
	currency: string;
	date: string;
	status: StripeTransactionStatus;
	type: StripeTransactionType;
};

export type StripeTransaction = {
	id: string;
	amount: number;
	fee: number;
	net: number;
	currency: string;
	date: DateTime;
	status: StripeTransactionStatus;
	type: StripeTransactionType;
};

export function hydrateStripeTransaction(data: StripeTransactionApiResponse): StripeTransaction {
	return {
		...data,
		date: DateTimefromISO(data.date)!,
	};
}